import { render, staticRenderFns } from "./single-listing.vue?vue&type=template&id=61530300&scoped=true&"
import script from "./single-listing.vue?vue&type=script&lang=js&"
export * from "./single-listing.vue?vue&type=script&lang=js&"
import style0 from "./single-listing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./single-listing.vue?vue&type=style&index=1&id=61530300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61530300",
  null
  
)

export default component.exports